/** Hide module dev hints unless explicitly enabled (e.g. REACT_APP_SHOW_DEV_HINTS=true). */
export const showDevHints = process.env.REACT_APP_SHOW_DEV_HINTS === 'true';

export const isProd = process.env.NODE_ENV === 'production';
export const isDev = process.env.NODE_ENV === 'development';
